module.exports = __webpack_public_path__ + "img/mac-calendar-subscribe.5e6c5dc0.png";